/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
// eslint-disable-next-line object-curly-newline
import { Container, Button, Grid, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import Main from '../container/Main';

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
      placeholderChar={'\u2000'}
    />
  );
};


const SelecionarCliente = (props) => {
  const [cpf, setcpf] = useState('');
  const [titulo, setTitulo] = useState('');

  const login = () => {
    localStorage.setItem('cpfCliente', cpf);
    localStorage.setItem('tituloCliente', titulo);
    // eslint-disable-next-line react/no-this-in-sfc
    props.history.push('/boletos');
  };

  const handleCPF = (event) => {
    setcpf(event.target.value);
  };

  const handleTitulo = (event) => {
    setTitulo(event.target.value);
  };

  return (
    <Main>
      <Container style={{ padding: '10px' }}>
        <Grid container spacing={2} direction="column" justify="center" alignItems="center">
          <Grid item>
            <TextField
              label="CPF"
              variant="filled"
              // value={cpf}
              // onChange={handleCPF}
              InputProps={{
                inputComponent: TextMaskCustom,
                value: cpf,
                onChange: handleCPF,
              }}
            />
          </Grid>
          <Grid item>
            <TextField
              label="Título"
              variant="filled"
              value={titulo}
              onChange={handleTitulo}
            />
          </Grid>
          <Grid item>
            <Button variant="contained" color="primary" onClick={login}>ENTRAR</Button>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default withRouter(SelecionarCliente);
